import createModule from "../createModule"
import { Creators as DialogCreators } from "modules/dialog/model"
import { Creators as ExperimentsCreators } from "modules/experiments/model"
import { Creators as ResearchTopics } from "modules/research-topic/model"
import { getComparisonItems } from "modules/compare-segments-root/selectors"
import { Creators } from "./model"
import { getExperimentLimitReached } from "./selectors"
import view from "./view"

export default createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    accountId: state.global.selected.accountId,
    portfolioId: props?.portfolioId,
    portfolioAlias: props?.portfolioAlias,
  }),
  required: ["account"],
  data: [{
    passthrough: true,
    resource: "experiments",
    as: null,
    url: ({ account }) => `/api/${account}/experiments`,
  }],
  mapStateToProps: (state, props) => ({
    newExperiment: state.modules.saveExperiment.newExperiment,
    updatedExperimentId: state.modules.saveExperiment.updatedExperimentId,
    currentComparisonItems: getComparisonItems(state),
    experimentLimitReached: getExperimentLimitReached(state, props),
  }),
  actions: {
    ...Creators,
    loadNewExperiment: ExperimentsCreators.loadNewExperiment,
    loadResearchTopicNewExperiment: ResearchTopics.loadNewExperiment,
    openDialog: DialogCreators.open,
    closeDialog: DialogCreators.close,
  },
})
